import { SETTINGS_TABS, type SettingsTab } from "../types/settings.types";

interface Props {
  tab: SettingsTab;
  onSelect: (tab: SettingsTab) => void;
}

export default function SettingsTabBar({ tab, onSelect }: Props) {
  return (
    <div className="flex gap-1 mb-6 border-b border-border overflow-x-auto overflow-y-hidden scrollbar-none">
      {SETTINGS_TABS.map(({ id, label }) => (
        <button
          key={id}
          onClick={() => onSelect(id)}
          className={`shrink-0 whitespace-nowrap px-3 sm:px-4 py-2 text-sm font-medium border-b-2 -mb-px transition-colors ${
            tab === id
              ? "border-primary text-foreground"
              : "border-transparent text-muted-foreground hover:text-foreground"
          }`}
        >
          {label}
        </button>
      ))}
    </div>
  );
}
